<div class="container-fluid complyon-page my-tasks-page px-3 px-md-4 py-3">
  <div class="complyon-shell my-tasks-shell mx-auto">
    <section class="my-tasks-header mb-3">
      <div class="d-flex flex-column gap-3">
        <div>
          <h1 class="my-tasks-title mb-2">My tasks</h1>
          <p class="my-tasks-subtitle mb-0">
            Daily work queue for approvals, declarations, evidence requests, training and overdue items.
          </p>
        </div>

      </div>
    </section>

    <section class="my-tasks-toolbar-panel rounded-4 mb-3">
      <div class="d-flex flex-column gap-3">
        <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between gap-3">
          <div class="my-tasks-viewing-wrap d-flex flex-wrap align-items-center gap-2">
            <span class="my-tasks-viewing-label">VIEWING AS</span>
            <div class="my-tasks-role-group d-inline-flex flex-wrap align-items-center gap-1">
              <button
                v-for="role in roles"
                :key="role.id"
                type="button"
                class="btn my-tasks-role-btn d-inline-flex align-items-center gap-2"
                :class="active_role === role.id ? 'active' : ''"
                @click="set_role(role.id)"
              >
                <i class="bi" :class="role.icon"></i>
                <span>{{ role.label }}</span>
              </button>
            </div>
          </div>

          <button
            type="button"
            class="btn my-tasks-primary-btn d-inline-flex align-items-center gap-2"
            @click="open_new_task_modal"
          >
            <i class="bi bi-plus-lg"></i>
            <span>New / delegate</span>
          </button>

        </div>

        <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between gap-3">
          <div class="my-tasks-filters d-inline-flex flex-wrap align-items-center gap-1">
            <button
              type="button"
              class="btn my-tasks-toggle-btn d-inline-flex align-items-center gap-2"
              :class="view_mode === 'category' ? 'active' : ''"
              @click="set_view_mode('category')"
            >
              <i class="bi bi-list-check"></i>
              <span>By category</span>
            </button>
            <button
              type="button"
              class="btn my-tasks-toggle-btn d-inline-flex align-items-center gap-2"
              :class="view_mode === 'source' ? 'active' : ''"
              @click="set_view_mode('source')"
            >
              <i class="bi bi-diagram-3"></i>
              <span>By source event</span>
            </button>
          </div>

          <div class="my-tasks-pills d-inline-flex flex-wrap align-items-center gap-1 rounded-4 p-1">
            <button
              v-for="filter in visible_filters"
              :key="filter.id"
              type="button"
              class="btn my-tasks-pill-btn"
              :class="active_filter === filter.id ? 'active' : ''"
              @click="set_filter(filter.id)"
            >
              <span>{{ filter.label }}</span>
              <span class="my-tasks-pill-count">{{ filter.count }}</span>
            </button>
          </div>

          <div class="my-tasks-owner-meta text-nowrap">
            {{ active_role_label }} · {{ active_owner }}
          </div>
        </div>

        <div v-if="view_mode === 'source'" class="my-tasks-source-note command-centre-panel rounded-4 px-3 py-2">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-info-circle my-tasks-source-note-icon"></i>
            <span>
              One event in any module fans out into linked tasks across owners - each carrying the same record. This is how Complyon replaces “email compliance”. Tasks owned by others are shown dimmed for context.
            </span>
          </div>
        </div>
      </div>
    </section>

    <section v-if="view_mode === 'category'" class="my-tasks-summary-strip mb-3">
      <div class="row g-3">
        <div
          v-for="metric in visible_metrics"
          :key="metric.label"
          class="col-12 col-md-6 col-xl-3"
        >
          <article
            class="my-tasks-metric-card rounded-4 p-3 h-100"
            :class="[
              active_filter === metric.id ? 'is-active' : '',
              'is-clickable',
              `is-${metric.id}`
            ]"
            :role="'button'"
            tabindex="0"
            @click="open_filter(metric.id)"
            @keydown.enter="open_filter(metric.id)"
            @keydown.space.prevent="open_filter(metric.id)"
          >
            <div class="my-tasks-metric-label mb-2">{{ metric.label }}</div>
            <div class="my-tasks-metric-value" :class="metric.tone ? `is-${metric.tone}` : ''">{{ metric.value }}</div>
            <div class="my-tasks-metric-subtitle">{{ metric.subtitle }}</div>
          </article>
        </div>
      </div>
    </section>

    <section class="my-tasks-filter-panel rounded-4 mb-3">
      <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center justify-content-between gap-3">
        <div class="my-tasks-filters d-inline-flex flex-wrap align-items-center gap-1">
          <button
            type="button"
            class="btn my-tasks-toggle-btn d-inline-flex align-items-center gap-2"
            :class="view_mode === 'category' ? 'active' : ''"
            @click="set_view_mode('category')"
          >
            <i class="bi bi-list-check"></i>
            <span>By category</span>
          </button>
          <button
            type="button"
            class="btn my-tasks-toggle-btn d-inline-flex align-items-center gap-2"
            :class="view_mode === 'source' ? 'active' : ''"
            @click="set_view_mode('source')"
          >
            <i class="bi bi-diagram-3"></i>
            <span>By source event</span>
          </button>
        </div>

        <div v-if="view_mode === 'category'" class="my-tasks-pills d-inline-flex flex-wrap align-items-center gap-1 rounded-4 p-1">
          <button
            v-for="filter in visible_filters"
            :key="filter.id"
            type="button"
            class="btn my-tasks-pill-btn"
            :class="active_filter === filter.id ? 'active' : ''"
            @click="set_filter(filter.id)"
          >
            <span>{{ filter.label }}</span>
            <span class="my-tasks-pill-count">{{ filter.count }}</span>
          </button>
        </div>

        <div v-if="view_mode === 'category'" class="my-tasks-owner-meta text-nowrap">
          {{ active_role_label }} · {{ active_owner }}
        </div>
      </div>

      <div v-if="view_mode === 'source'" class="my-tasks-source-note command-centre-panel rounded-4 px-3 py-2 mt-3">
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-info-circle my-tasks-source-note-icon"></i>
          <span>
            One event in any module fans out into linked tasks across owners - each carrying the same record. This is how Complyon replaces "email compliance". Tasks owned by others are shown dimmed for context.
          </span>
        </div>
      </div>
    </section>

    <section v-if="view_mode === 'category'" class="my-tasks-sections my-tasks-content d-flex flex-column gap-3">
      <template v-if="visible_groups.length">
        <article
          v-for="group in visible_groups"
          :key="group.id"
          class="my-tasks-group-card command-centre-panel rounded-4 overflow-hidden"
        >
          <div class="my-tasks-group-head d-flex align-items-start justify-content-between gap-3">
            <div class="d-flex align-items-start gap-3 min-w-0">
              <span class="my-tasks-group-icon d-inline-flex align-items-center justify-content-center">
                <i class="bi" :class="group.icon"></i>
              </span>
              <div class="min-w-0">
                <div class="my-tasks-group-title">{{ group.title }}</div>
                <div class="my-tasks-group-subtitle">{{ group.subtitle }}</div>
              </div>
            </div>
            <span class="my-tasks-group-count">{{ group.tasks.length }}</span>
          </div>

          <div class="my-tasks-group-list">
            <article
              v-for="task in group.tasks"
              :key="task.id"
              class="my-tasks-task-row d-flex align-items-center justify-content-between gap-3"
              :class="task.drawer_key ? 'is-clickable' : ''"
              :role="task.route_name || task.drawer_key ? 'button' : null"
              :tabindex="task.route_name || task.drawer_key ? 0 : null"
              @click="open_task(task)"
              @keydown.enter="open_task(task)"
              @keydown.space.prevent="open_task(task)"
            >
              <div class="d-flex align-items-start gap-3 min-w-0">
                <input
                  class="form-check-input my-tasks-check flex-shrink-0"
                  type="checkbox"
                  :aria-label="`Select ${task.title}`"
                  @click.stop
                >
                <div class="min-w-0">
                  <div class="my-tasks-task-title">{{ task.title }}</div>
                  <div class="my-tasks-task-subtitle">{{ task.subtitle }}</div>
                  <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
                    <span
                      v-for="tag in task.tags"
                      :key="tag"
                      class="my-tasks-tag badge rounded-pill"
                    >
                      {{ tag }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="my-tasks-task-meta d-flex align-items-center gap-3 flex-shrink-0">
                <div class="my-tasks-due">{{ task.due }}</div>
                <span class="badge rounded-pill my-tasks-status-pill" :class="task.status_class">
                  {{ task.status }}
                </span>
                <button
                  type="button"
                  class="btn my-tasks-gear-btn d-inline-flex align-items-center justify-content-center"
                  @click.stop="open_edit_task_modal(task)"
                  aria-label="Edit task"
                >
                  <i class="bi bi-gear"></i>
                </button>
              </div>
            </article>
          </div>
        </article>
      </template>

      <article v-else class="my-tasks-empty-state command-centre-panel rounded-4 overflow-hidden">
        <div class="my-tasks-empty-state-inner d-flex flex-column align-items-center justify-content-center text-center">
          <div class="my-tasks-empty-icon d-inline-flex align-items-center justify-content-center rounded-circle mb-3">
            <i class="bi bi-check2-circle"></i>
          </div>
          <h3 class="my-tasks-empty-title mb-2">All clear</h3>
          <p class="my-tasks-empty-copy mb-0">
            No tasks match this filter for {{ active_role_label }}.
          </p>
        </div>
      </article>
    </section>

    <section v-else class="my-tasks-source-sections my-tasks-content d-flex flex-column gap-3">
      <article
        v-for="group in source_event_groups"
        :key="group.id"
        class="my-tasks-source-card command-centre-panel rounded-4 overflow-hidden"
      >
        <div class="my-tasks-source-head">
          <div class="d-flex align-items-start justify-content-between gap-3">
            <div class="d-flex align-items-start gap-3 min-w-0">
              <span class="my-tasks-source-icon d-inline-flex align-items-center justify-content-center" :class="`is-${group.tone}`">
                <i class="bi" :class="group.icon"></i>
              </span>
              <div class="min-w-0">
                <div class="d-flex flex-wrap align-items-center gap-2">
                  <div class="my-tasks-source-title">{{ group.title }}</div>
                  <span class="my-tasks-source-badge badge rounded-pill">{{ group.badge }}</span>
                </div>
                <div class="my-tasks-source-subtitle">{{ group.subtitle }}</div>
                <div class="my-tasks-source-meta">{{ group.meta }}</div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
            <span
              v-for="owner in group.owners"
              :key="owner"
              class="my-tasks-owner-chip badge rounded-pill"
              :class="owner === active_role_label ? 'is-active' : ''"
            >
              <i class="bi" :class="owner === active_role_label ? 'bi-shield-check' : 'bi-person'"></i>
              <span>{{ owner }}</span>
            </span>
          </div>
        </div>

        <div class="my-tasks-group-list">
          <article
            v-for="task in group.tasks"
            :key="task.id"
            class="my-tasks-task-row my-tasks-task-row--source d-flex align-items-center justify-content-between gap-3"
            :class="[
              task.route_name || task.drawer_key ? 'is-clickable' : '',
              task_is_owned_by_active_role(task) ? '' : 'is-muted'
            ]"
            :role="task.route_name || task.drawer_key ? 'button' : null"
            :tabindex="task.route_name || task.drawer_key ? 0 : null"
            @click="open_task(task)"
            @keydown.enter="open_task(task)"
            @keydown.space.prevent="open_task(task)"
          >
            <div class="d-flex align-items-start gap-3 min-w-0">
              <input
                class="form-check-input my-tasks-check flex-shrink-0"
                type="checkbox"
                :aria-label="`Select ${task.title}`"
                @click.stop
              >
              <div class="min-w-0">
                <div class="my-tasks-task-title">{{ task.title }}</div>
                <div class="my-tasks-task-subtitle">{{ task.subtitle }}</div>
                <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
                  <span
                    class="my-tasks-tag badge rounded-pill"
                    :class="task_is_owned_by_active_role(task) ? 'is-active' : 'is-muted'"
                  >
                    <i class="bi" :class="task_is_owned_by_active_role(task) ? 'bi-shield-check' : 'bi-shield'"></i>
                    <span>{{ active_role_label }}</span>
                  </span>
                  <span
                    v-for="tag in task.tags.slice(0, 2)"
                    :key="tag"
                    class="my-tasks-tag badge rounded-pill"
                    :class="task_is_owned_by_active_role(task) ? 'is-active' : 'is-muted'"
                  >
                    {{ tag }}
                  </span>
                </div>
              </div>
            </div>

            <div class="my-tasks-task-meta d-flex align-items-center gap-3 flex-shrink-0">
              <div class="my-tasks-due">{{ task.due }}</div>
              <span class="badge rounded-pill my-tasks-status-pill" :class="task.status_class">
                {{ task.status }}
              </span>
                <button
                  type="button"
                  class="btn my-tasks-gear-btn d-inline-flex align-items-center justify-content-center"
                  @click.stop="open_edit_task_modal(task)"
                  aria-label="Edit task"
                >
                  <i class="bi bi-gear"></i>
                </button>
            </div>
          </article>
        </div>
      </article>
    </section>
  </div>

  <div
    v-if="active_drawer"
    class="command-centre-drawer-backdrop"
    @click="close_drawer"
  ></div>

  <aside
    v-if="active_drawer"
    class="command-centre-drawer"
    aria-label="Task detail drawer"
  >
    <div class="command-centre-drawer-header border-bottom">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <div class="command-centre-drawer-kicker text-uppercase">{{ active_drawer.section }}</div>
          <h2 class="command-centre-drawer-title mb-1 text-truncate">{{ active_drawer.title }}</h2>
          <div class="command-centre-drawer-subtitle text-truncate">{{ active_drawer.subtitle }}</div>
        </div>
        <div class="d-flex align-items-center gap-2 flex-shrink-0">
          <span class="badge rounded-pill" :class="active_drawer.status_class">{{ active_drawer.status }}</span>
          <button
            type="button"
            class="btn btn-link text-decoration-none p-0 command-centre-drawer-close"
            @click="close_drawer"
            aria-label="Close drawer"
          >
            <i class="bi bi-x-lg fs-5"></i>
          </button>
        </div>
      </div>
    </div>

    <div ref="drawerBody" class="command-centre-drawer-body">
      <template v-if="active_drawer.details || active_drawer.sections">
        <div
          v-if="active_drawer.details_layout === 'list'"
          class="command-centre-drawer-details-list mb-4"
        >
          <div
            v-for="row in active_drawer.details"
            :key="row.label"
            class="command-centre-drawer-details-row d-flex align-items-start justify-content-between gap-3"
          >
            <div class="command-centre-drawer-meta-label text-nowrap">{{ row.label }}</div>
            <div class="command-centre-drawer-meta-value text-end" :class="row.value_class || ''">{{ row.value }}</div>
          </div>
        </div>

        <div v-else class="row g-3 mb-4">
          <div
            v-for="row in active_drawer.details"
            :key="row.label"
            class="col-12 col-md-6"
          >
            <div class="command-centre-drawer-meta">
              <div class="command-centre-drawer-meta-label">{{ row.label }}</div>
              <div class="command-centre-drawer-meta-value" :class="row.value_class || ''">{{ row.value }}</div>
            </div>
          </div>
        </div>

        <section
          v-for="section in active_drawer.sections"
          :key="section.title"
          class="mb-4"
        >
          <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
            <div class="command-centre-drawer-section-title">{{ section.title }}</div>
            <span class="badge rounded-pill" :class="section.badge_class">{{ section.badge }}</span>
          </div>

          <div v-if="section.kind === 'items'" class="d-flex flex-column gap-2">
            <article
              v-for="item in section.items"
              :key="item.title"
              class="command-centre-drawer-item d-flex align-items-start justify-content-between gap-3"
            >
              <div class="d-flex align-items-start gap-2 min-w-0">
                <span :class="['command-centre-drawer-item-icon d-inline-flex align-items-center justify-content-center', item.icon_class]">
                  <i class="bi" :class="item.icon"></i>
                </span>
                <div class="min-w-0">
                  <div class="command-centre-drawer-item-title">{{ item.title }}</div>
                  <div class="command-centre-drawer-item-subtitle">{{ item.subtitle }}</div>
                  <div class="command-centre-drawer-item-meta">{{ item.meta }}</div>
                </div>
              </div>
              <span
                v-if="item.badge"
                class="badge rounded-pill text-nowrap fw-semibold"
                :class="item.badge_class"
              >
                {{ item.badge }}
              </span>
            </article>
          </div>

          <div v-else-if="section.kind === 'timeline'" class="position-relative ps-1">
            <div class="command-centre-drawer-timeline">
              <article
                v-for="item in section.items"
                :key="item.title"
                :class="[
                  'command-centre-drawer-timeline-item',
                  item.connected ? 'is-connected' : ''
                ]"
              >
                <span :class="['command-centre-drawer-timeline-badge', item.icon_class]">
                  <i class="bi" :class="item.icon"></i>
                </span>
                <span v-if="item.connected" class="command-centre-drawer-timeline-line"></span>
                <div class="command-centre-drawer-timeline-content">
                  <div class="command-centre-drawer-item-title">{{ item.title }}</div>
                  <div v-if="item.subtitle" class="command-centre-drawer-item-subtitle">{{ item.subtitle }}</div>
                  <div v-if="item.meta" class="command-centre-drawer-timeline-meta">
                    <span>{{ item.meta }}</span>
                  </div>
                </div>
              </article>
            </div>
          </div>

          <div v-else-if="section.kind === 'progress'" class="d-flex flex-column gap-3">
            <div
              v-for="item in section.items"
              :key="item.label"
              class="command-centre-drawer-progress-row"
            >
              <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
                <div class="d-flex align-items-center gap-2 min-w-0">
                  <span class="command-centre-drawer-dot rounded-circle flex-shrink-0" :style="{ backgroundColor: item.dot }"></span>
                  <div class="command-centre-drawer-item-title text-truncate">{{ item.label }}</div>
                </div>
                <div class="d-flex align-items-center gap-3 flex-shrink-0">
                  <span class="command-centre-drawer-progress-value">{{ item.percent }}%</span>
                  <span class="command-centre-drawer-progress-count">{{ item.count }}</span>
                </div>
              </div>
              <div class="progress rounded-pill command-centre-drawer-progress">
                <div class="progress-bar bg-success" :style="{ width: `${item.percent}%` }"></div>
              </div>
            </div>
          </div>
        </section>
      </template>

      <template v-else>
        <div class="h-100 d-flex align-items-center justify-content-center text-center px-3">
          <div>
            <div class="d-inline-flex align-items-center justify-content-center rounded-circle bg-light text-secondary mb-3" style="width: 3rem; height: 3rem;">
              <i class="bi bi-info-circle"></i>
            </div>
            <div class="fw-semibold text-dark mb-1">{{ active_drawer.body_title }}</div>
            <div class="small text-secondary">
              {{ active_drawer.body_copy }}
            </div>
          </div>
        </div>
      </template>
    </div>

    <div v-if="active_drawer.footer_actions && active_drawer.footer_actions.length" class="command-centre-drawer-footer border-top">
      <div class="d-flex flex-wrap gap-2 align-items-center">
        <div
          v-if="active_drawer_footer_primary_actions.length"
          class="command-centre-drawer-footer-left d-flex align-items-center gap-2"
        >
          <button
            v-for="action in active_drawer_footer_primary_actions"
            :key="action.label"
            type="button"
            class="btn d-inline-flex align-items-center gap-2"
            :class="action.variant === 'primary'
              ? 'config-navbar-primary-action'
              : action.variant === 'secondary'
                ? 'config-navbar-secondary-action'
                : action.variant === 'outline-danger'
                  ? 'btn-outline-danger'
                  : action.variant === 'outline-warning'
                    ? 'btn-outline-warning'
                    : action.variant === 'outline-secondary'
                      ? 'btn-outline-secondary'
                      : 'btn-link text-decoration-none text-secondary px-0'"
          >
            <i class="bi" :class="action.icon"></i>
            <span>{{ action.label }}</span>
          </button>
        </div>

        <div class="command-centre-drawer-footer-actions ms-auto d-flex flex-wrap gap-2 align-items-center">
          <button
            v-for="action in active_drawer_footer_actions"
            :key="action.label"
            type="button"
            class="btn d-inline-flex align-items-center gap-2"
            :class="action.variant === 'primary'
              ? 'config-navbar-primary-action'
              : action.variant === 'secondary'
                ? 'config-navbar-secondary-action'
                : action.variant === 'outline-danger'
                  ? 'btn-outline-danger'
                  : action.variant === 'outline-warning'
                    ? 'btn-outline-warning'
                    : action.variant === 'outline-secondary'
                      ? 'btn-outline-secondary'
                      : 'btn-link text-decoration-none text-secondary px-0'"
          >
            <i class="bi" :class="action.icon"></i>
            <span>{{ action.label }}</span>
          </button>
        </div>
      </div>
    </div>
  </aside>

  <teleport to="body">
    <div
      v-if="show_edit_task_modal"
      class="my-tasks-modal-backdrop"
      @click="close_edit_task_modal"
    ></div>

    <section
      v-if="show_edit_task_modal"
      class="my-tasks-modal"
      aria-label="Edit task dialog"
    >
      <div class="my-tasks-modal-panel my-tasks-modal-panel--edit">
        <div class="my-tasks-modal-header">
          <div class="d-flex align-items-start justify-content-between gap-3">
            <div class="min-w-0">
              <h2 class="my-tasks-modal-title mb-2">Edit task</h2>
              <p class="my-tasks-modal-subtitle mb-0">
                Every task carries an owner, a linked record, an SLA and the attributes that joined it.
              </p>
            </div>
            <button
              type="button"
              class="btn btn-link text-decoration-none p-0 my-tasks-modal-close"
              @click="close_edit_task_modal"
              aria-label="Close modal"
            >
              <i class="bi bi-x-lg fs-4"></i>
            </button>
          </div>
        </div>

        <div class="my-tasks-modal-body">
          <div class="my-tasks-modal-section-label">THE TASK</div>
          <div class="row g-3">
            <div class="col-12">
              <label class="my-tasks-modal-field-label">TASK <span class="text-danger">*</span></label>
              <input v-model="edit_task_form.task" type="text" class="form-control my-tasks-modal-input" placeholder="What needs doing">
            </div>
            <div class="col-12">
              <label class="my-tasks-modal-field-label">DETAIL</label>
              <input v-model="edit_task_form.detail" type="text" class="form-control my-tasks-modal-input" placeholder="Context — what to check, attach or decide">
            </div>
            <div class="col-12 col-lg-6">
              <label class="my-tasks-modal-field-label">OWNER</label>
              <select v-model="edit_task_form.owner" class="form-select my-tasks-modal-select">
                <option v-for="option in new_task_owner_options" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div class="col-12 col-lg-6">
              <label class="my-tasks-modal-field-label">CATEGORY</label>
              <select v-model="edit_task_form.category" class="form-select my-tasks-modal-select">
                <option v-for="option in new_task_category_options" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div class="col-12 col-lg-6">
              <label class="my-tasks-modal-field-label">TIMING</label>
              <input v-model="edit_task_form.timing" type="text" class="form-control my-tasks-modal-input" placeholder="Optional timing note">
            </div>
            <div class="col-12 col-lg-6">
              <label class="my-tasks-modal-field-label">STATUS / SLA</label>
              <select v-model="edit_task_form.status_sla" class="form-select my-tasks-modal-select">
                <option v-for="option in new_task_status_options" :key="option" :value="option">{{ option }}</option>
              </select>
              <div class="my-tasks-modal-help">Drives the colour and the summary tiles above.</div>
            </div>
            <div class="col-12 col-lg-6">
              <label class="my-tasks-modal-field-label">DUE</label>
              <input v-model="edit_task_form.due" type="text" class="form-control my-tasks-modal-input" placeholder="3 days">
              <div class="my-tasks-modal-help">How it reads on the row - keep it consistent with the SLA.</div>
            </div>
            <div class="col-12 col-lg-6">
              <label class="my-tasks-modal-field-label">ESCALATION LEVEL</label>
              <select v-model="edit_task_form.escalation_level" class="form-select my-tasks-modal-select">
                <option v-for="option in new_task_escalation_options" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
          </div>

          <div class="my-tasks-modal-section-label mt-4">WHERE IT CAME FROM & WHAT IT POINTS TO</div>
          <div class="row g-3">
            <div class="col-12">
              <label class="my-tasks-modal-field-label">SOURCE EVENT (FAN-OUT)</label>
              <select v-model="edit_task_form.source_event" class="form-select my-tasks-modal-select">
                <option v-for="option in new_task_source_event_options" :key="option" :value="option">{{ option }}</option>
              </select>
              <div class="my-tasks-modal-help">Attach to an event to make this task part of its cross-module chain. The linked record pre-fills from the event.</div>
            </div>
            <div class="col-12 col-lg-6">
              <label class="my-tasks-modal-field-label">LINKED RECORD ID</label>
              <input v-model="edit_task_form.linked_record_id" type="text" class="form-control my-tasks-modal-input" placeholder="e.g. C-216">
            </div>
            <div class="col-12 col-lg-6">
              <label class="my-tasks-modal-field-label">RECORD MODULE</label>
              <select v-model="edit_task_form.record_module" class="form-select my-tasks-modal-select">
                <option v-for="option in new_task_domain_options" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div class="col-12">
              <label class="my-tasks-modal-field-label">RECORD LABEL</label>
              <input v-model="edit_task_form.record_label" type="text" class="form-control my-tasks-modal-input" placeholder="e.g. Supplier tax monitoring">
            </div>
            <div class="col-12">
              <div class="my-tasks-modal-field-label mb-2">ATTRIBUTES THAT JOINED THIS TASK</div>
              <div class="d-flex flex-wrap gap-2">
                <button
                  type="button"
                  class="btn my-tasks-attribute-pill"
                  :class="edit_task_form.attribute_approval ? 'active' : ''"
                  @click="edit_task_form.attribute_approval = !edit_task_form.attribute_approval"
                >
                  <i class="bi bi-arrow-return-right"></i>
                  <span>Approval required</span>
                </button>
                <button
                  type="button"
                  class="btn my-tasks-attribute-pill"
                  :class="edit_task_form.attribute_evidence ? 'active' : ''"
                  @click="edit_task_form.attribute_evidence = !edit_task_form.attribute_evidence"
                >
                  <i class="bi bi-journal-text"></i>
                  <span>Evidence required</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="my-tasks-modal-footer my-tasks-modal-footer--edit">
          <button type="button" class="btn my-tasks-modal-delete d-inline-flex align-items-center gap-2" @click="delete_edit_task">
            <i class="bi bi-trash"></i>
            <span>Delete</span>
          </button>

          <div class="ms-auto d-flex align-items-center gap-2">
            <button type="button" class="btn my-tasks-modal-cancel" @click="close_edit_task_modal">Cancel</button>
            <button type="button" class="btn my-tasks-modal-submit d-inline-flex align-items-center gap-2" @click="save_edit_task">
              <i class="bi bi-check2-square"></i>
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <div
      v-if="show_new_task_modal"
      class="my-tasks-modal-backdrop"
      @click="close_new_task_modal"
    ></div>

    <section
      v-if="show_new_task_modal"
      class="my-tasks-modal"
      aria-label="New delegate task dialog"
    >
      <div class="my-tasks-modal-panel">
        <div class="my-tasks-modal-header">
          <div class="d-flex align-items-start justify-content-between gap-3">
            <div class="min-w-0">
              <h2 class="my-tasks-modal-title mb-2">New / delegate task</h2>
              <p class="my-tasks-modal-subtitle mb-0">
                Every task carries an owner, a linked record, an SLA and the attributes that joined it.
              </p>
            </div>
            <button
              type="button"
              class="btn btn-link text-decoration-none p-0 my-tasks-modal-close"
              @click="close_new_task_modal"
              aria-label="Close modal"
            >
              <i class="bi bi-x-lg fs-4"></i>
            </button>
          </div>
        </div>

        <div class="my-tasks-modal-body">
        <div class="my-tasks-modal-section-label">THE TASK</div>
        <div class="row g-3">
          <div class="col-12">
            <label class="my-tasks-modal-field-label">TASK <span class="text-danger">*</span></label>
            <input v-model="new_task_form.task" type="text" class="form-control my-tasks-modal-input" placeholder="What needs doing">
          </div>
          <div class="col-12">
            <label class="my-tasks-modal-field-label">DETAIL</label>
            <input v-model="new_task_form.detail" type="text" class="form-control my-tasks-modal-input" placeholder="Context — what to check, attach or decide">
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">OWNER</label>
            <select v-model="new_task_form.owner" class="form-select my-tasks-modal-select">
              <option v-for="option in new_task_owner_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">CATEGORY</label>
            <select v-model="new_task_form.category" class="form-select my-tasks-modal-select">
              <option v-for="option in new_task_category_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">ASSIGNEE</label>
            <input v-model="new_task_form.assignee" type="text" class="form-control my-tasks-modal-input" placeholder="Person or team you delegated this to">
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">TIMING</label>
            <input v-model="new_task_form.timing" type="text" class="form-control my-tasks-modal-input" placeholder="Optional timing note">
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">DUE</label>
            <input v-model="new_task_form.due" type="text" class="form-control my-tasks-modal-input" placeholder="3 days">
            <div class="my-tasks-modal-help">How it reads on the row - keep it consistent with the SLA.</div>
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">STATUS / SLA</label>
            <select v-model="new_task_form.status_sla" class="form-select my-tasks-modal-select">
              <option v-for="option in new_task_status_options" :key="option" :value="option">{{ option }}</option>
            </select>
            <div class="my-tasks-modal-help">Drives the colour and the summary tiles above.</div>
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">ESCALATION LEVEL</label>
            <select v-model="new_task_form.escalation_level" class="form-select my-tasks-modal-select">
              <option v-for="option in new_task_escalation_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>
        </div>

        <div class="my-tasks-modal-section-label mt-4">WHERE IT CAME FROM & WHAT IT POINTS TO</div>
        <div class="row g-3">
          <div class="col-12">
            <label class="my-tasks-modal-field-label">SOURCE EVENT (FAN-OUT)</label>
            <select v-model="new_task_form.source_event" class="form-select my-tasks-modal-select">
              <option v-for="option in new_task_source_event_options" :key="option" :value="option">{{ option }}</option>
            </select>
            <div class="my-tasks-modal-help">Attach to an event to make this task part of its cross-module chain. The linked record pre-fills from the event.</div>
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">LINKED RECORD ID</label>
            <input v-model="new_task_form.linked_record_id" type="text" class="form-control my-tasks-modal-input" placeholder="e.g. REQ-204">
          </div>
          <div class="col-12 col-lg-6">
            <label class="my-tasks-modal-field-label">RECORD LABEL</label>
            <input v-model="new_task_form.record_label" type="text" class="form-control my-tasks-modal-input" placeholder="e.g. IT hardware RFQ">
          </div>
          <div class="col-12">
            <label class="my-tasks-modal-field-label">POINTS TO</label>
            <select v-model="new_task_form.points_to" class="form-select my-tasks-modal-select">
              <option v-for="option in new_task_domain_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>
          <div class="col-12">
            <div class="my-tasks-modal-field-label mb-2">ATTRIBUTES THAT JOINED THIS TASK</div>
            <div class="d-flex flex-wrap gap-2">
              <button
                type="button"
                class="btn my-tasks-attribute-pill"
                :class="new_task_form.attribute_approval ? 'active' : ''"
                @click="new_task_form.attribute_approval = !new_task_form.attribute_approval"
              >
                <i class="bi bi-arrow-return-right"></i>
                <span>Approval required</span>
              </button>
              <button
                type="button"
                class="btn my-tasks-attribute-pill"
                :class="new_task_form.attribute_evidence ? 'active' : ''"
                @click="new_task_form.attribute_evidence = !new_task_form.attribute_evidence"
              >
                <i class="bi bi-journal-text"></i>
                <span>Evidence required</span>
              </button>
            </div>
          </div>
        </div>
        </div>

        <div class="my-tasks-modal-footer">
          <button type="button" class="btn my-tasks-modal-cancel" @click="close_new_task_modal">Cancel</button>
          <button type="button" class="btn my-tasks-modal-submit d-inline-flex align-items-center gap-2">
            <i class="bi bi-plus-lg"></i>
            <span>Create task</span>
          </button>
        </div>
      </div>
    </section>
  </teleport>
</div>
